import { redirect } from "@client/content/modules/actions";
import { makeRedirectToSelector } from "@client/content/selectors";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector } from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";
import { type Leaderboard } from "../../types";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = EntityRef & {
  values: Leaderboard.View.UserData;
};
const makeMapStateToProps = () => {
  const termsRedirectSelector = makeRedirectToSelector(TargetSelector.Entity, "terms");
  const privacyRedirectSelector = makeRedirectToSelector(TargetSelector.Entity, "privacy");

  return (state: AppState, props: Props): MapProps => {
    return {
      ...props,
      hasPrivacy: !!privacyRedirectSelector(state, props),
      hasTerms: !!termsRedirectSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onPrivacyClick: () =>
    dispatch(
      redirect({
        id: props.id,
        target: TargetSelector.Entity,
        prefix: "privacy",
        source: props.source
      })
    ),
  onTermsClick: () =>
    dispatch(
      redirect({
        id: props.id,
        target: TargetSelector.Entity,
        prefix: "terms",
        source: props.source
      })
    )
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
